<template>
  <div class="doctorpc-apply-sign">
    <docpc-steps :current="stepActive"></docpc-steps>
    <div class="docpc-panel">
      <div class="form-box">
        <div class="docpc-form-title">医生签名</div>
        <div class="canvas-page">
          <div class="signatureBox">
            <div class="canvasBox" ref="canvasHW">
              <canvas ref="canvasF"
                @mousedown="mouseDown"
                @mousemove="mouseMove"
                @mouseup="mouseUp"
              >
              </canvas>
            </div>
            <div v-if="imgUrl" class="imgCanvas" :sytle="'background-image: url('+broadbg+');'">
              <img :src="imgUrl" alt="">
            </div>
          </div>
        </div>
        <div class="page_tips">如需重新签名，请先点击右侧的“清除”按钮再手写签名，签名完成后请点击“保存”按钮保存。</div>
        <div class="docpc-form-btn">
          <div class="btn-item">
            <van-button block size="small" :disabled="btnDisabled" @click="goBack()">返回</van-button>
          </div>
          <div class="btn-item">
            <van-button :color="themeColor" block size="small" :disabled="btnDisabled" @click.native="commit">保存</van-button>
          </div>
          <div class="btn-item">
            <van-button block size="small" :disabled="btnDisabled" @click.native="overwrite">清除</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import broadbg from "@/assets/docpc/broad_bg.png"
import docpcSteps from "@/doctor_pc/components/steps/steps.vue"
import {
  doctorComplete
} from '@/api/doctorapi';
import {
  Toast,
} from "vant";
import {
  mapState,
  mapActions
} from "vuex";

export default {
  name: 'docpcApplySign',
  components: {
    docpcSteps,
  },
  data() {
    return {
      broadbg: broadbg,
      themeColor: this.themeColor,
      stepActive: null,
      btnDisabled: false,
      baseFileUrl: this.baseUrl,
      stageInfo:'',
      imgUrl:'',
      client: {},
      points: [],
      canvasTxt: null,
      startX: 0,
      startY: 0,
      moveY: 0,
      moveX: 0,
      endY: 0,
      endX: 0,
      w: null,
      h: null,
      isDown: false,
      isReady: false,
    }
  },
  computed: {
    ...mapState(['docpc']),
  },
  created() {
    console.log('ssss',this.docpc.docpcForm.doctor)
    if(this.docpc.docpcForm && this.docpc.docpcForm.doctor.signature_image) {
      let img = this.docpc.docpcForm.doctor.signature_image
      if (img.indexOf('base64') != -1) {
        this.imgUrl = img
      } else {
        this.imgUrl = this.baseFileUrl + img
      }
    } else if (this.docpc.docpcInfo.doctor && this.docpc.docpcInfo.doctor.signature_image) {
      this.imgUrl = this.baseFileUrl + this.docpc.docpcInfo.doctor.signature_image
    }
    setTimeout(() => {
      //手写板
      let canvas = this.$refs.canvasF
      canvas.height = this.$refs.canvasHW.offsetHeight - 2
      canvas.width = this.$refs.canvasHW.offsetWidth -2
      console.log(this.$refs.canvasHW.offsetWidth)
      this.canvasTxt = canvas.getContext('2d')
      this.stageInfo = canvas.getBoundingClientRect()
      this.isReady = true
    }, 500)
  },
  methods: {
    ...mapActions(['SET_DOCPC_FORM']),
    goBack() {
      this.$router.back()
    },
    isBase64(str) {
      if (str === '' || str.trim() === '') {
        return false
      }
      try {
        return btoa(atob(str)) == str;
      } catch {
        return false
      }
    },
    //pc 手写板
    mouseDown(ev) {
      if(!this.isReady) return;
      ev = ev || event
      ev.preventDefault()
      if (1) {
        let obj = {
          x: ev.offsetX,
          y: ev.offsetY
        }
        this.startX = obj.x
        this.startY = obj.y
        this.canvasTxt.beginPath()
        this.canvasTxt.moveTo(this.startX, this.startY)
        this.canvasTxt.lineTo(obj.x, obj.y)
        this.canvasTxt.stroke()
        this.canvasTxt.closePath()
        this.points.push(obj)
        this.isDown = true
      }
    },
    mouseMove(ev) {
      if(!this.isReady) return;
      ev = ev || event
      ev.preventDefault()
      if (this.isDown) {
        let obj = {
          x: ev.offsetX,
          y: ev.offsetY
        }
        this.moveY = obj.y
        this.moveX = obj.x
        this.canvasTxt.beginPath()
        this.canvasTxt.moveTo(this.startX, this.startY)
        this.canvasTxt.lineTo(obj.x, obj.y)
        this.canvasTxt.stroke()
        this.canvasTxt.closePath()
        this.startY = obj.y
        this.startX = obj.x
        this.points.push(obj)
      }
    },
    mouseUp(ev) {
      if(!this.isReady) return;
      ev = ev || event
      ev.preventDefault()
      if (1) {
        let obj = {
          x: ev.offsetX,
          y: ev.offsetY
        }
        this.canvasTxt.beginPath()
        this.canvasTxt.moveTo(this.startX, this.startY)
        this.canvasTxt.lineTo(obj.x, obj.y)
        this.canvasTxt.stroke()
        this.canvasTxt.closePath()
        this.points.push(obj)
        this.points.push({x: -1, y: -1})
        this.isDown = false
      }
    },
    //重写
    overwrite() {
      this.canvasTxt.clearRect(0, 0, this.$refs.canvasF.width, this.$refs.canvasF.height)
      this.points = []
      this.imgUrl = ''
    },
    //提交签名
    commit() {
      console.log('this.imgUrl',this.points.length,this.imgUrl)
      if (this.points.length==0 && !this.imgUrl) {
        Toast('请先签名再保存')
        return
      }
      if (this.points.length!=0 && !this.imgUrl) {
        this.imgUrl=this.$refs.canvasF.toDataURL()
        let req = this.docpc.docpcForm
        req.doctor.signature_image = this.imgUrl
        this.SET_DOCPC_FORM(req)
      }
      this.$router.back()
    },
    submit() {
      
    },
  }
}
</script>

<style lang='less'>
.doctorpc-apply-sign {
  .docpc-form {
    .from { margin-bottom: 0;}
    .van-cell {
      padding: 6px 16px;
    }
    .van-field__label {
      text-align: right;
    }
    .van-cell--required {
      &::before { display: none; }
      .van-field__label {
        &::before {
          color: #ee0a24; font-size: 14px; content: '*';
        }
      }
    }
  }
  .page_tips {
    padding: 20px 0; text-align: center; color: #999;
  }
  .canvas-page {
    position: relative;
    width: 500px;
    height: 270px;
    margin: auto;
  }
  .imgCanvas {
    width: 100%; height: 100%; position: absolute; top: 0; left: 0;
    background: #BBD0FA center center no-repeat;
    background-size: 75% auto;
    border: #eee solid 1px;
    img {
      height: 100%; width: 100%; display: block; object-fit: contain;
    }
  }
  .signatureBox {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    // max-width: 600px;
    // // height: calc(100% - 50px);
    // height: 300px;
    box-sizing: border-box;
    overflow: hidden;
    background: #fff;
    z-index: 100;
    // display: flex;
    // flex-direction: column;
  }
  .canvasBox {
    box-sizing: border-box; height: 100%;
    // flex: 1;
  }
  canvas {
    margin: auto; width: 100%;
    background: #BBD0FA center center no-repeat;
    background-image: url('~@/assets/docpc/broad_bg.png');
    background-size: 75% auto;
    border: #eee solid 1px;
  }
  .canvas-btn {
    width: 500px; margin-top: 20px;
  }
}
</style>